<template>
  <div class="grid crud-demo">
    <div class="col-12">
      <transition-group name="p-messages" tag="div" class="col-12 md:col-12" v-if="messages.length > 0">
        <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
      </transition-group>
      <CardProcesso :processo="processo" />
      <div v-if="temProcessos" class="card">
        <Toast />

        <Toolbar class="mb-4">
          <template #start>
            <div>
              <span v-tooltip.bottom="{value:'Não é possível atualizar gabarito nesta fase', disabled: processo.estadoSelecao.podeInformarGabarito}" >
                <Button label="Gabaritos" icon="pi pi-file-o" class="mr-2 p-button-secondary" @click="showGabaritosDialg()" :disabled="!processo.estadoSelecao.podeInformarGabarito"/>
              </span>
              <Button label="Respostas Candidatos" icon="pi pi-file-o" class="mr-2 p-button-secondary" @click="showRespostasCandidatosDialg()" :disabled="!processo.estadoSelecao.podeInformarGabarito"/>
              <!-- <Button label="Respostas Discursivas" icon="pi pi-file-o" class="mr-2 p-button-secondary" @click="showRespostasDiscursivasCandidatosDialg()" :disabled="!processo.estadoSelecao.podeInformarGabarito"/> -->
              <Button label="Respostas Discursivas" icon="pi pi-file-o" class="mr-2 p-button-secondary" @click="showRespostasDiscursivasCandidatosDialg()"/>
              <Button label="Processar Respostas" icon="pi pi-file-o" class="mr-2 p-button" @click="processarRespostas()" :disabled="!processo.estadoSelecao.podeGerarResultado"/>
            </div>
          </template>
          <template #end>
            <Button label="Exportar" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)"/>
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="inscricoes"
          :selection.sync="selectedNotas"
          dataKey="identificador"
          :paginator="true"
          :rows="10"
          :filters.sync="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} notas"
          responsiveLayout="scroll"
          filterDisplay="row"
          class="p-datatable-sm p-datatable-customers"
          :globalFilterFields="['codInscricao']">
          <template #header>
            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
              <h5 class="m-0">Notas</h5>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText v-model="filters['global'].value" placeholder="Filtrar..."/>
              </span>
            </div>
          </template>

          <Column :headerStyle="{ width: '30em' }" field="codInscricao" header="Inscrição" :sortable="true"/>
          <Column :headerStyle="{ width: '15em' }" field="nomeArea" header="Área" :sortable="true"/>
          <Column field="notaProva" header="Nota" :sortable="true" />
          <Column field="notaProvaDiscursiva" header="Nota Discursiva" :sortable="true" />
          <Column field="comparecimento" header="Presente" dataType="boolean" class="col-12 md:col-1 m-5" :headerStyle="{ width: '7em' }" style="margin-right: 5em">
            <template #body="{data}">
              {{ data.comparecimento == true ? "Sim" : "Não" }}
            </template>
            <template #filter="{filterModel,filterCallback}">
              <TriStateCheckbox
                v-model="filterModel.value"
                @change="filterCallback()"
              />
            </template>
          </Column>
          <Column :headerStyle="{ width: '15em' }">
            <template #body="slotProps">
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editNota(slotProps.data)" :disabled="!podeAlterarNota"/>
            </template>
          </Column>
        </DataTable>

        <Dialog :visible.sync="notaDialog" :style="{ width: '450px' }" header="Detalhes da Nota" :modal="true" class="p-fluid">
          <transition-group name="p-messages" tag="div" class="col-12 md:col-4">
            <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{ msg.content }}</Message>
          </transition-group>

          <div class="field grid">
            <label for="inscricao">Inscrição</label>
            <InputText id="inscricao" v-model="nota.codInscricao" required="true" autofocus
                      :class="{ 'p-invalid': submitted && !nota.inscricao }" disabled="true"/>
            <small class="p-invalid" v-if="submitted && !nota.codInscricao">Inscrição é obrigatória</small>
          </div>

          <div class="field grid" v-if="!nota.ausente">
            <label for="nome" class="col-12 md:col-12">Nota</label>
            <InputNumber id="nota" v-model="nota.notaProva" mode="decimal" locale="pt-BR"
                        :minFractionDigits="2" :maxFractionDigits="2" style="width:100px"
                        disabled="true"/>
            <small class="p-invalid" v-if="submitted && !nota.nota">Nota é obrigatória</small>
          </div>

          <div class="field grid">
            <label for="nome" class="mr-4">Presente</label>
            <Checkbox v-model="nota.comparecimento" :binary="true" />
          </div>

          <template #footer>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              label="Salvar"
              type="submit"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveNota"
            />
          </template>
        </Dialog>

        <Gabarito :gabaritosDialog.sync="gabaritoDialog" :processoSeletivo="processo"/>
        <RespostasCandidato :respostaDialog.sync="respostasDialog" :processoSeletivo="processo" tipoProva="OBJETIVA"/>
        <RespostasCandidato :respostaDialog.sync="respostasDialogDiscursiva" :processoSeletivo="processo" tipoProva="DISCURSIVA"/>
      </div>
    </div>
  </div>
</template>

<script>
import NotaService from "../../service/NotaService";
import ProcessoService from "../../service/ProcessoService";
import InscricaoService from "../../service/InscricaoService";
import { FilterMatchMode } from "primevue/api";
import CardProcesso from "../../components/CardProcesso.vue";
import Gabarito from "../../components/gabarito/Gabarito.vue";
import RespostasCandidato from "../../components/gabarito/RespostasCandidato.vue";
import { tratamentoDeErros } from "@/tratamentoDeErros";

export default {
  mixins: [tratamentoDeErros],
  components: { CardProcesso, Gabarito, RespostasCandidato },
  data() {
    return {
      notas: null,
      messages: [],
      notaDialog: false,
      gabaritoDialog: false,
      respostasDialog: false,
      respostasDialogDiscursiva: false,
      deleteNotaDialog: false,
      deleteNotasDialog: false,
      nota: { comparecimento: false },
      selectedNotas: null,
      filters: {},
      submitted: false,
      matchModeOptions: [],

      temProcessos: false,
      processo: [],
      dropdownValues: ["Não", "Sim"],
      inscricao: {
        identificador: null,
        codInscricao: null,
        candidato: null,
        coefic_red_escolar: null,
        comprovante_red_escolar_id: null,
        estado: "",
        mensagem: "",
      },

      candidato: null,
      inscricaoAntes: null,
      inscricoes: null,
      inscricoesByEstado: [],
      inscricaoDialog: false,
      deleteinscricaoDialog: false,
      deleteinscricoesDialog: false,

      processoService: null,
      notaService: null,

      podeAlterarNota: false,
    };
  },

  created() {
    this.notaService = new NotaService();
    this.processoService = new ProcessoService();
    this.inscricaoService = new InscricaoService();
    this.initFilters();
  },
   mounted() {
    // this.processoService.getProcessoAtivo().then((resposta) => {
    // this.processo = resposta.data[0];
    // });
    this.getProcessoAtivo();
  },
  watch: {
  	processoSelecionado() {
      this.processo = this.processoSelecionado;
      this.getProcessoAtivo();
  	}
  },
  computed: {
    processoSelecionado: {
      get() {
        return this.$store.state.processoSelecionado;
      },
    }
  },
  methods: {
    getProcessoAtivo() {
      this.processoService.getProcesso(this.processoSelecionado.id)
        .then((resposta) => {
          this.processo = resposta;
          this.processo.datHoraFimInscricao = this.formatarDataBR(
            this.processo.datHoraFimInscricao
          );
          this.processo.datHoraInicioInscricao = this.formatarDataBR(
            this.processo.datHoraInicioInscricao
          );
          this.temProcessos = true;
          console.log(this.processo.tipoSelecao);
          this.podeAlterarNota = this.processo.estadoSelecao.podeAlterarNota;
          this.carregarInscricoes();
        }).catch(() => {});
    },
    carregarInscricoes() {
      this.inscricaoService
        .findAllWithNotas(this.processo.id)
        .then((inscricoes) => {
          this.inscricoes = inscricoes;
          // console.log("inscricoes: ", JSON.stringify(this.inscricoes, null, 3));
        });
    },

    formatarDataBR(dataUS) {
      return new Date(dataUS).toLocaleString();
    },
    initFilters() {
      this.filters = {
        comparecimento: { value: null, matchMode: FilterMatchMode.EQUALS },

        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    openNew() {
      this.nota = {};
      this.submitted = false;
      this.notaDialog = true;
    },
    hideDialog() {
      this.notaDialog = false;
      this.submitted = false;
    },
    saveNota() {
      if (this.nota.identificador) {
        this.updateNota();
      } else {
        this.createNota();
      }
    },
    editNota(nota) {
      this.nota = { ...nota };
      this.notaDialog = true;
    },
    confirmDeleteNota(nota) {
      this.nota = nota;
      this.deleteNotaDialog = true;
    },
    deleteNota() {
      this.notas = this.notas.filter((val) => val.id !== this.nota.id);
      this.deleteNotaDialog = false;
      this.nota = {};
      this.$toast.add({
        severity: "success",
        summary: "Successo",
        detail: "Nota excluída",
        life: 3000,
      });
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.notas.length; i++) {
        if (this.notas[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    exportCSV() {
      this.inscricaoService.exportarInscricoesNotaCSV(this.processo.id, 'inscricao_nota');
    },
    exportCSV_dataTable() {
      var tmp =  JSON.parse(JSON.stringify(this.$refs.dt.value));
      var tmp2 = this.$refs.dt.value

      tmp.forEach(element => {
        console.log( element);
        element.comparecimento = element.comparecimento == true? 'sim':'não';
      });

      this.$refs.dt.value = tmp;
      this.$refs.dt.exportCSV();
      this.$refs.dt.value = tmp2;

    },
    confirmDeleteSelected() {
      this.deleteNotasDialog = true;
    },
    deleteSelectedNotas() {
      this.notas = this.notas.filter(
        (val) => !this.selectedNotas.includes(val)
      );
      this.deleteNotasDialog = false;
      this.selectedNotas = null;
      this.$toast.add({
        severity: "success",
        summary: "Sucesso",
        detail: "Notas excluidas",
        life: 3000,
      });
    },

    createNota() {
      this.notas.push(this.nota);
      this.$toast.add({
        severity: "success",
        summary: "Sucesso",
        detail: `Área ${this.nota.nome} criada`,
        life: 3000,
      });
      this.nota = {};
      this.submitted = false;
      document.getElementById("inscricao").focus();
    },
    updateNota() {
      if (!this.nota.comparecimento) this.nota.comparecimento = false;

      this.inscricaoService
        .inserirNota(this.nota.codInscricao, this.nota)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: `Inscrição ${this.nota.codInscricao} foi atualizada com sucesso`,
            life: 3000,
          });

          this.carregarInscricoes();
          this.hideDialog();
        })
        .catch((erro) => {
          this.messages = this.getMessagesError(erro);
        });
    },
    addMessageError(errors) {
      for (let i = 0; i < errors.length; i++) {
        this.messages.push({
          severity: "error",
          content: `${errors[i].message}`,
        });
      }
    },
    showGabaritosDialg() {
      this.gabaritoDialog = true;
    },
    showRespostasCandidatosDialg() {
      this.respostasDialog = true;
    },
    showRespostasDiscursivasCandidatosDialg() {
      this.respostasDialogDiscursiva = true;
    },
    processarRespostas() {
      this.messages = [];
      this.$store.state.dlgLoading = true;
      this.processoService.processaResultadoGabarito(this.processo.id)
          .then(() => {
              this.$toast.add({
                severity: "success",
                summary: "Sucesso",
                detail: `Gabarito processado com sucesso`,
                life: 3000,
              });
              this.carregarInscricoes();
              this.$store.state.dlgLoading = false;
            })
            .catch((erro) => {
              this.$store.state.dlgLoading = false;
              this.messages = this.getMessagesError(erro);
            });
    }
  },
};
</script>
